import React from "react";

//Images
import why1 from "../images/why-us/pavers.svg";
import why2 from "../images/why-us/workers.svg";
import why3 from "../images/why-us/customer-service.svg";

const WhyUs = () => {
  return (
    <div className="row justify-content-center panel-why-us">
      <div className="col-11 col-xl-10">
        <div className="row">
          <div className="col-12 text-center">
            <h3 className="text-uppercase text-blue mb-1 pb-3">Why have us install your pavers?</h3>
          </div>
        </div>
        <div className="row justify-content-around mt-0">
          <div className="col-10 col-lg-4 mt-4 mt-lg-0 text-center">
            <img src={why1} alt="Feature" className="w-40"/>
            <h4 className="text-uppercase">Top Paving Stone<br/>Professionals</h4>
            <p className="mt-3">
              We have a team of highly talented paving stone professionals to
              help you create the outdoor space you’ve been dreaming of. The
              owners of the company are not only ICPI (Interlocking Concrete
              Paver Institute) certified, but are also instructors, teaching
              other contractors how to properly install paving stones.
            </p>
          </div>
          <div className="col-10 col-lg-4 mt-4 mt-lg-0 text-center">
            <img src={why2} alt="Feature" className="w-40"/>
            <h4 className="text-uppercase">
              Fully-Trained,<br/>Professional In-house Crews
            </h4>
            <p className="mt-3">
              Our crews are employed by us; we don’t send out subcontracted
              strangers to work on your project. We ensure our crews are trained
              to the highest standards and up-to-date on the latest installation
              techniques.
            </p>
          </div>
          <div className="col-10 col-lg-4 mt-4 mt-lg-0 text-center">
            <img src={why3} alt="Feature" className="w-40"/>
            <h4 className="text-uppercase">
              Customer Service<br/>that can't be beat
            </h4>
            <p className="mt-3">
              Every finished project is followed up with a customer service call
              to ensure the project went off without a hitch. Any problems or
              concerns are handled until you’re 100% satisfied.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
